export default __webpack_public_path__ + "65de6f023544f879d5681c668b3e5f4a.png";